import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MediaQuery from "react-responsive";
import { useTranslation } from "react-i18next";

import { scrollToSection } from "../../redux/nav/nav.actions";

import MenuButton from "../menu-button/menu-button.component";
import PrimaryButton from "../primary-button/primary-button.component";

import "./header.styles.scss";

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const isOverGallery = useSelector(
    (state: { nav: { isOverGallery: boolean } }) => state.nav.isOverGallery,
  );
  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    const checkWindowScroll = () => {
      setShowHeader(window.pageYOffset >= window.innerHeight - 80);
    };

    window.addEventListener("scroll", checkWindowScroll);
    return () => window.removeEventListener("scroll", checkWindowScroll);
  }, []);

  const fade = showHeader ? "fade-in" : "fade-out";
  const { t } = useTranslation();

  return (
    <MediaQuery maxWidth={1024}>
      {(matches: boolean) => {
        const invert = isOverGallery && !matches ? "inverted" : null;
        return (
          <div className={`header ${fade} ${invert}`}>
            <MenuButton inverted={isOverGallery && !matches} />
            <div
              className="logo-container"
              onClick={() => dispatch(scrollToSection("Home"))}
            >
              <img
                alt="Too Far East Barber"
                className="logo-image"
                src={
                  isOverGallery && !matches
                    ? `${process.env.PUBLIC_URL}/TFE_white_logo.svg`
                    : `${process.env.PUBLIC_URL}/TFE_black_logo.svg`
                }
              />
            </div>
            <div className="book-button">
              <PrimaryButton
                tiny
                inverted={!isOverGallery || matches}
                onClick={() => dispatch(scrollToSection("Contact"))}
              >
                {matches ? t("common.book") : t("common.bookNow")}
              </PrimaryButton>
            </div>
          </div>
        );
      }}
    </MediaQuery>
  );
};

export default Header;
